export const environment = {
  production: true,
  apiUrl: 'https://eveneum.dev.duomo.net.pl/api/v1/',
  imagesHost: 'https://eveneum.dev.duomo.net.pl'
};



// WEBPACK FOOTER //
// /dist/src/environments/environment.ts